import Vue from 'vue';
import VueGoogleMaps from 'vue-googlemaps';

import App from './App.vue';
import router from './router';
import store from './store';
import './registerServiceWorker';
import i18n from './i18n';

// eslint-disable-next-line import/extensions
import './plugins/iview.js';

import { createProvider } from './vue-apollo';
import 'vue-googlemaps/dist/vue-googlemaps.css';

Vue.use(VueGoogleMaps, {
  load: {
    // Google API key
    apiKey: 'AIzaSyDF0YHrwPNDNF86da8TNc7HqfSQ0QOwcj0',
    // Enable more Google Maps libraries here
    libraries: ['places'],
    // Use new renderer
    useBetaRenderer: false,
  },
});

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  i18n,
  apolloProvider: createProvider(),
  render: h => h(App),
}).$mount('#app');
